module.exports = __webpack_public_path__ + "static/media/mvc.d6bdc9dd.png";